import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import { AnalysisAction, fetchOneAnalysis, setAnalyses, setOneAnalysis } from './actions'
import { AnalysesState } from './analyses.types'

export const analysesReducer = combineReducers<AnalysesState, AnalysisAction>({
  items: (analyses = {}, action) => {
    switch (action.type) {
      case getType(setAnalyses):
        return action.payload
      case getType(setOneAnalysis):
      case getType(fetchOneAnalysis.success): {
        const analysis = action.payload
        return { ...analyses, [analysis.id]: analysis }
      }
      default:
        return analyses
    }
  },
})
